export const TRACKING_ERRORS = [
  {
    error: 'pageView',
    description: 'Error while tracking page view',
  },
] as const;

export type TrackingError = typeof TRACKING_ERRORS[number]['error'];
